import type { PulseContextProviderConfig } from './types/index.js';

import { frontendConfig } from '../../system/config/frontend.server.js';

const defaultPulseConfig: PulseContextProviderConfig = {
  ...frontendConfig.pulseConfig,
};

export { defaultPulseConfig };
